import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'hpLabelFilter'
})
export class HpLabelFilterPipe implements PipeTransform {

  constructor(private translate?: TranslateService) {}

  transform(value: any, args?: any): any {

    if(!value)return null;
    if(!args)return value;

    args = args.toLowerCase();
    return value.filter((item) => {
      return (
        JSON.stringify(this.translate?.instant(item?.label))?.toLowerCase().includes(args) ||
        (item?.model && item?.model.toLowerCase().includes(args)) ||
        (Array.isArray(item?.serial_number) && item?.serial_number.some(x => JSON.stringify(x).toLowerCase().includes(args)))
      );
    });

}

}
